import styled from 'styled-components';

export const ModalMessageContent = styled.div`
    display: grid;
    gap: 8px;
`;

export const ModalMessageContentItem = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 100px auto;

    span {
        font-weight: 700;
    }

    p {
        margin: 0;
        padding: 0;
    }
`;